import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const List = styled.ul`
    padding-left: 20px;
`;

const MaintenanceToolTip = () => {
    const { t } = useTranslation(['moduleDetails', 'maintenance']);

    return (
        <Container>
            <div>{t('maintenance:tooltip.format')}</div>
            <List>
                <li>{t('maintenance:tooltip.formatWeek')}</li>
                <li>{t('maintenance:tooltip.formatDay')}</li>
                <li>{t('maintenance:tooltip.formatHour')}</li>
                <li>{t('maintenance:tooltip.formatMinute')}</li>
            </List>
        </Container>
    );
};

export default MaintenanceToolTip;
